var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config.data.length)?_c('dv-scroll-ranking-board',{staticClass:"board",attrs:{"config":_vm.config}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }